import { Avatar } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

const AVATAR_GREY = '#bdbdbd';

/**
 * A blank grey person, where the dashboard shows someone without a photo: a provider in the
 * selector, a guest on a booking. The dashboard's own; the guest pages draw theirs with
 * `ProviderAvatar`.
 */
const PersonAvatar = ({ size = 36, sx }) => (
  <Avatar sx={{ width: size, height: size, color: '#fff', backgroundColor: AVATAR_GREY, ...sx }}>
    <PersonIcon sx={{ fontSize: size * 0.7 }} />
  </Avatar>
);

export default PersonAvatar;
